'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _zoroRequest = require('@alife/zoro-request');

var _zoroRequest2 = _interopRequireDefault(_zoroRequest);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _util = require('./util');

var _zoroArms = require('@alife/zoro-arms');

var _zoroArms2 = _interopRequireDefault(_zoroArms);

var _i18n = require('../i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _verification = require('./verification');

var _verification2 = _interopRequireDefault(_verification);

var _phonepwd = require('./phonepwd');

var _phonepwd2 = _interopRequireDefault(_phonepwd);

var _zoroClickstat = require('@alife/zoro-clickstat');

var _zoroClickstat2 = _interopRequireDefault(_zoroClickstat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TelePhone = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(TelePhone, _Component);

    function TelePhone(props) {
        (0, _classCallCheck3.default)(this, TelePhone);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TelePhone.__proto__ || Object.getPrototypeOf(TelePhone)).call(this, props));

        _this.slidChecked = true;
        _this.ncAppKey = '';
        _this.ncToken = '';
        _this.phoneNc = null;
        _this.ncData = {};
        _this.slideBoxId = 'register-phone-slide-box';
        _this.cellPhone = '';
        _this.countryCodeFormat = '';
        _this.countryCodeData = [{
            classname: 'ru',
            countryCode: '+7'
        }, {
            classname: 'sa',
            countryCode: '+966'
        }, {
            classname: 'ae',
            countryCode: '+971'
        }, {
            classname: 'es',
            countryCode: '+34'
        }];

        _this.state = {
            showCountryList: false, // 展示countrycode列表
            countryCode: props.countryCode, // countryCode
            countryCodeClassName: props.countryCodeClassName || 'ru', // countryCode对应的类名
            showDropDown: false, // 是否展示countryCode下拉列表

            phoneValue: '', // 手机号码
            isShowPhoneTip: false, // 是否显示手机号错误提示
            showPhoneTip: '', // 展示错误信息提示
            phoneError: '', // 手机输入框验证错误
            phoneExistTip: false, // 展示手机号码已存在

            isShowPhoneSlide: false, // 展示人机校验滑块 默认为false
            isShowPhoneSlideTip: false, // 是否展示人际校验错误提示
            showPhoneSlideTip: '', // 展示人机校验错误提示

            isShowPhoneTab: true, // 展示手机注册页
            isShowVerificationTab: false, // 展示验证码页
            isShowPwdTab: false, // 展示密码页

            countDownTimer: null, // 验证码倒计时定时器id
            isResend: false, // 是否重发验证码

            isShowCodeTip: false, // 是否显示验证码错误提示
            showCodeTip: '', // 展示验证码错误信息
            showResendCode: false, // 展示重新发送验证码
            showCountDown: true // 展示倒计时


        };
        props.showAgreement(false);
        _this.selectCountryCode = _this.selectCountryCode.bind(_this);
        _this.onPhoneBlur = _this.onPhoneBlur.bind(_this);
        _this.onPhoneChange = _this.onPhoneChange.bind(_this);
        _this.onSendSMSCode = _this.onSendSMSCode.bind(_this);
        _this.onGuideSignIn = _this.onGuideSignIn.bind(_this);
        _this.showPhoneTab = _this.showPhoneTab.bind(_this);
        _this.checkSMSAjax = _this.checkSMSAjax.bind(_this);
        _this.getResend = _this.getResend.bind(_this);
        _this.setCountDownTimer = _this.setCountDownTimer.bind(_this);
        _this.getShowCodeTip = _this.getShowCodeTip.bind(_this);
        _this.getCountDown = _this.getCountDown.bind(_this);
        _this.showPwdTab = _this.showPwdTab.bind(_this);
        return _this;
    } // 人机校验通过

    // 滑动验证appKey

    // 滑动验证token

    // 人机校验对象

    // 渲染人机校验指定id

    // 手机最后一次提交的值 格式 7-1111111111

    // 标准格式的countryCode

    (0, _createClass3.default)(TelePhone, [{
        key: 'selectCountryCode',


        /**
         * 选择countrycode
         */
        value: function selectCountryCode(item) {
            this.setState({
                showCountryList: !this.state.showCountryList,
                showDropDown: !this.state.showDropDown,
                countryCode: item.countryCode ? item.countryCode : this.state.countryCode,
                countryCodeClassName: item.classname ? item.classname : this.state.countryCodeClassName
            });
        }

        /**
         * 获取验证码提示信息
         * @param {bealoon} beal // 是否展示验证码提示
         * @param {string} tipInfo // 验证码提示信息
         */

    }, {
        key: 'getShowCodeTip',
        value: function getShowCodeTip(beal, tipInfo) {
            var stateInfo = {
                isShowCodeTip: beal
            };
            stateInfo = beal ? { isShowCodeTip: beal, showCodeTip: tipInfo } : stateInfo;
            this.setState(stateInfo);
        }

        /**
         * 获取倒计时信息
         * @param {bealoon} isCountdown // 展示倒计时
         * @param {bealoon} isResendcode // 展示重发验证码
         */

    }, {
        key: 'getCountDown',
        value: function getCountDown(isCountdown, isResendcode) {
            this.setState({
                showCountDown: isCountdown,
                showResendCode: isResendcode
            });
        }

        /**
         * 手机号码失焦
         */

    }, {
        key: 'onPhoneBlur',
        value: function onPhoneBlur() {
            var phoneObjVal = this.state.phoneValue;
            if (!phoneObjVal) return; // 手机号码注册框有内容才出发校验
            var r = /^[\d]{9,12}$/; // 9-12位阿拉伯数字
            // phone输入完成后点击打点
            this.clickDot({
                buttonType: 'phone',
                objectType: 'input_box'
            });
            if (phoneObjVal.length < 9 || phoneObjVal.length > 12) {
                this.setState({
                    phoneError: 'input-error',
                    showPhoneTip: _i18n2.default.VALID_NUMBER,
                    isShowPhoneTip: true,
                    isShowPhoneSlide: false,
                    isShowPhoneSlideTip: false
                });
                this.slidChecked = true;
                return false;
            } else if (r.test(phoneObjVal)) {
                this.setState({
                    phoneError: '',
                    isShowPhoneTip: false
                });
                // 注册手机号前端校验通过
                this.clickDot({
                    buttonType: 'register_phone_do_sendcode',
                    objectType: 'input_box'
                });
                return true;
            } else {
                this.setState({
                    phoneError: 'input error',
                    showPhoneTip: _i18n2.default.VALID_NUMBER,
                    isShowPhoneTip: true,
                    isShowPhoneSlide: false,
                    isShowPhoneSlideTip: false
                });
                this.slidChecked = true;
                return false;
            }
        }
    }, {
        key: 'onPhoneChange',
        value: function onPhoneChange(e) {
            this.setState({
                phoneValue: e.target.value
            });
        }

        /**
         * 发送验证码
         */

    }, {
        key: 'onSendSMSCode',
        value: function onSendSMSCode() {
            this.props.toggleMask(true);
            var check = this.onPhoneBlur();
            this.onSlideChecked();
            if (check && this.slidChecked) {
                // 前端校验通过
                this.countryCodeFormat = this.state.countryCode.replace(/\+/, '');
                this.checkSMSAjax();
            } else {
                this.setState({
                    phoneError: 'input-error',
                    showPhoneTip: _i18n2.default.VALID_NUMBER,
                    isShowPhoneTip: true,
                    isShowPhoneSlideTip: false
                });
                this.props.toggleMask(false);
            }
        }

        /**
         * 预校验手机号，发送验证码接口
         *  {
         *      "isDisplayCheckCode": true,  -- 意味着要显示滑动验证
         *      "ncAppkey": -- 滑动验证的appkey
         *      "ncToken": --  滑动验证的token
         *  }
         *  {
         *      "result": true,  -- 返回验证结果，true 或者 false， true的话进入下一个步骤
         *      "isDisplayCheckCode": false,
         *      "codeInfo": "send verification code success!",
         *      "code": 10 -- resultCode，是一个整数值
         *  }
         * 接口文档及返回code信息详见 https://yuque.antfin-inc.com/ck7ftz/acrr51/gfetiq
         */

    }, {
        key: 'checkSMSAjax',
        value: function checkSMSAjax() {
            var _this2 = this;

            this.cellPhone = this.countryCodeFormat + '-' + this.state.phoneValue;
            (0, _zoroRequest2.default)({
                url: 'https://login.aliexpress.com/join/PreCheckForPhoneRegister.htm',
                dataType: 'json',
                timeout: 5000,
                data: {
                    cellPhone: this.cellPhone,
                    sig: this.ncData ? this.ncData.sig : '', // 滑动验证户自动生成，有的话则传
                    csessionid: this.ncData ? this.ncData.csessionid : '', // 滑动验证后自动生成，有的话则传
                    umidToken: this.props.nCf ? this.props.nCf.getUmidToken() : '',
                    ua: this.props.nCf ? this.props.nCf.getUA() : '',
                    registerFrom: this.props.registerFrom
                },
                withCredentials: true // 支持附带详细信息
            }).then(function (res) {
                _this2.props.toggleMask(false);
                if (res.result) {
                    if (res.isDisplayCheckCode) {
                        // 需要人机校验
                        _this2.needSlideCheck(res);
                    } else {
                        _this2.slidChecked = true;
                        _this2.setState({
                            isShowPhoneSlide: false
                        });
                        // 展示注册验证码页
                        _this2.setState({
                            isShowPhoneTab: false,
                            isShowVerificationTab: true // 展示验证码页
                        });
                    }
                } else if (res.isDisplayCheckCode) {
                    // 需要人机校验
                    _this2.needSlideCheck(res);
                } else if (!_this2.state.isResend) {
                    // 重发验证码
                    _this2.slidChecked = true;
                    _this2.setState({
                        isShowPhoneSlide: false,
                        isShowPhoneTip: true,
                        phoneError: 'input-error'
                    });
                    // 返回错误信息
                    if (res.code === 220) {
                        // 注册手机号码已存在
                        _this2.setState({
                            phoneExistTip: true,
                            showPhoneTip: res.codeInfo
                        });
                    } else {
                        _this2.setState({
                            showPhoneTip: res.codeInfo
                        });
                    }
                    if (res.code === 120) {
                        // 手机号码不合法点击打点
                        _this2.clickDot({
                            buttonType: 'phone_invalid_error',
                            objectType: 'input_box'
                        });
                    } else if (res.code === 500) {
                        // 号码为空点击打点
                        _this2.clickDot({
                            buttonType: 'phone_empty_error',
                            objectType: 'input_box'
                        });
                    }
                } else {
                    // 重发验证码错误
                    window.clearInterval(_this2.state.countDownTimer); // 停止计时器
                    _this2.setSate({
                        isShowCodeTip: false,
                        showCodeTip: res.codeInfo,
                        showResendCode: true,
                        showCountDown: false
                    });
                }
            }).catch(function (err) {
                _this2.props.toggleMask(false);
                _this2.setState({
                    showPhoneTip: _i18n2.default.UNAVIALABLE_SERVICE,
                    isShowPhoneTip: true
                });
                _zoroArms2.default.error(err);
            });
        }

        /**
         * 需要进行滑动验证
         */

    }, {
        key: 'needSlideCheck',
        value: function needSlideCheck(res) {
            this.setState({
                isShowPhoneSlide: true
            });
            this.slidChecked = false;
            this.ncAppKey = res.ncAppKey;
            this.ncToken = res.ncToken;
            this.initNoCaptchaPhone();
            // 滑动验证曝光打点
            this.ctrDot({
                expType: 'phone'
            });
        }

        /**
         * 初始化滑动验证组件
         * H5参考文档:https://yuque.antfin-inc.com/captcha/srnklh/qdy2xg
         * PC参考文档:https://yuque.antfin-inc.com/captcha/srnklh/bzrrhm
         */

    }, {
        key: 'initNoCaptchaPhone',
        value: function initNoCaptchaPhone() {
            var self = this;
            if ((0, _util.isMobile)()) {
                window.NoCaptcha.upLang('cn', {
                    SLIDER_LABEL: _i18n2.default.SLIDE_SUBMIT,
                    CHECK_Y: _i18n2.default.SLIDE_SUBMIT_TIPS,
                    ERROR_TITLE: '<a href="javascript:__nc.reset()">Refresh</a>',
                    LOADING: _i18n2.default.LOADING
                });

                this.phoneNc = window.NoCaptcha.init({
                    renderTo: '#' + this.slideBoxId, // 渲染到该DOM ID指定的Div位置
                    appkey: this.ncAppKey, // 应用标识
                    scene: 'register_h5', // 常见的还有register_h5等
                    token: this.ncToken,
                    language: 'cn',
                    bannerHidden: false,
                    callback: function callback(data) {
                        // 校验成功回调
                        self.ncData = {};
                        self.ncData.csessionid = data.csessionid;
                        self.ncData.sig = data.sig;
                        self.setState({
                            isShowPhoneSlideTip: false
                        });
                        self.slidChecked = true; // 滑动验证通过
                        // 滑动验证成功 点击打点
                        self.clickDot({
                            buttonType: 'safety_verification',
                            objectType: 'button'
                        });
                    },
                    error: function error() {
                        // 失败回调,如果连不上服务器或者连续超时，会调此函数
                        self.clickDot({
                            buttonType: 'verification_fail',
                            objectType: 'button'
                        });
                    }
                });
                window.NoCaptcha.setEnabled(true);
                this.phoneNc.reset();
            } else {
                this.phoneNc = new window.noCaptcha({ // eslint-disable-line
                    renderTo: '#' + this.slideBoxId, // 渲染到该DOM ID指定的Div位置
                    appkey: this.ncAppKey, // 应用标识 CF_APP_AE_REGISTER
                    scene: 'register', // 常见的还有register_h5等
                    token: this.ncToken,
                    language: 'nc',
                    callback: function callback(data) {
                        // 校验成功回调
                        self.ncData = {};
                        self.ncData.csessionid = data.csessionid;
                        self.ncData.sig = data.sig;
                        self.setState({
                            isShowPhoneSlideTip: false
                        });
                        self.slidChecked = true; // 滑动验证通过
                        self.clickDot({
                            buttonType: 'safety_verification',
                            objectType: 'button'
                        });
                    },
                    error: function error() {
                        // 失败回调,如果连不上服务器或者连续超时，会调此函数
                        self.clickDot({
                            buttonType: 'verification_fail',
                            objectType: 'button'
                        });
                    }
                });
                this.phoneNc.upLang('cn', {
                    _startTEXT: _i18n2.default.SLIDE_SUBMIT,
                    _yesTEXT: _i18n2.default.SLIDE_SUBMIT_TIPS,
                    _error300: '<a href="javascript:__nc.reset()">Refresh</a>',
                    _errorNetwork: '<a href="javascript:__nc.reset()">Refresh</a>',
                    _Loading: _i18n2.default.LOADING
                });
                this.phoneNc.reload();
            }
        }

        /**
         * 校验滑动验证
         */

    }, {
        key: 'onSlideChecked',
        value: function onSlideChecked() {
            if (this.slidChecked) {
                this.setState({
                    isShowPhoneTip: false
                });
                return true;
            } else {
                this.setState({
                    isShowPhoneSlideTip: true,
                    showPhoneSlideTip: _i18n2.default.SLIDE_SUBMIT_ERROR_TIPS
                });
                return false;
            }
        }

        /**
         * 手机注册账号已存在引导至登陆页
         */

    }, {
        key: 'onGuideSignIn',
        value: function onGuideSignIn() {
            // 把这个点击Sign In的事件抛到父级组件
            // 这个抛出去的参数是最后一次经过检查的phone参数
            this.props.mailSignIn(this.cellPhone);
            // 注册失败引导至登陆页打点
            this.clickDot({
                buttonType: 'register_fail_signin',
                objectType: 'button'
            });
        }
    }, {
        key: 'showPhoneTab',
        value: function showPhoneTab() {
            this.setState({
                isShowPhoneTab: true,
                isShowVerificationTab: false,
                phoneValue: ''
            });
            this.props.showAgreement(false);
        }
    }, {
        key: 'getResend',
        value: function getResend(boolean) {
            this.setState({
                isResend: boolean
            });
        }

        // 设置 倒计时

    }, {
        key: 'setCountDownTimer',
        value: function setCountDownTimer(timerId) {
            this.setState({
                countDownTimer: timerId
            });
        }
    }, {
        key: 'showPwdTab',
        value: function showPwdTab() {
            this.setState({
                isShowPwdTab: true,
                isShowPhoneTab: false,
                isShowVerificationTab: false // 展示验证码页
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                { className: 'batman-join' },
                this.state.isShowPhoneTab ? _react2.default.createElement(
                    _react.Fragment,
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'input-box' },
                        _react2.default.createElement(
                            'div',
                            { className: 'country-code-wrap' },
                            _react2.default.createElement(
                                'div',
                                { className: 'country-code-inner', onClick: this.selectCountryCode },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'country-code' },
                                    this.state.countryCode
                                ),
                                _react2.default.createElement('div', { className: 'flag css_flag css_' + this.state.countryCodeClassName }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'drop-arrow-wrap' },
                                    this.state.showDropDown ? _react2.default.createElement('span', { className: 'drop-arrow drop-down' }) : _react2.default.createElement('span', { className: 'drop-arrow' })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'country-list', style: { display: this.state.showCountryList ? 'block' : 'none' } },
                                _react2.default.createElement(
                                    'ul',
                                    null,
                                    this.countryCodeData.map(function (item, index) {
                                        return _react2.default.createElement(
                                            'li',
                                            { key: index, onClick: function onClick() {
                                                    return _this3.selectCountryCode(item);
                                                } },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'country-item css_flag css_' + item.classname, code: item.classname },
                                                item.countryCode
                                            )
                                        );
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement('input', { type: 'tel', className: 'input-phone ' + this.state.phoneError, autoFocus: true, name: '', value: this.state.phoneValue, onChange: this.onPhoneChange, onBlur: this.onPhoneBlur, placeholder: _i18n2.default.PHONE_NUMBER }),
                        _react2.default.createElement(
                            'div',
                            { className: 'error-tip', style: { display: this.state.isShowPhoneTip ? 'block' : 'none' } },
                            this.state.phoneExistTip ? _react2.default.createElement(
                                'div',
                                null,
                                this.state.showPhoneTip,
                                '\xA0\xA0',
                                _react2.default.createElement(
                                    'a',
                                    { className: 'email-signin', onClick: this.onGuideSignIn },
                                    _i18n2.default.SIGN_IN + ' >',
                                    ' '
                                )
                            ) : this.state.showPhoneTip
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'input-box' },
                        _react2.default.createElement('div', { className: 'register-slide-box', id: this.slideBoxId, style: { display: this.state.isShowPhoneSlide ? 'block' : 'none' } }),
                        _react2.default.createElement(
                            'div',
                            { className: 'error-tip', style: { display: this.state.isShowPhoneSlideTip ? 'block' : 'none' } },
                            this.state.showPhoneSlideTip
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'edm-box' },
                        this.props.isShowEDM ? _react2.default.createElement('input', { checked: this.props.allowEDM, onChange: function onChange(param) {
                                _this3.props.handleChangeEDM(param);
                            }, type: 'checkbox', id: 'register-edm', name: 'edm-checkbox' }) : '',
                        this.props.isShowEDM ? _react2.default.createElement(
                            'span',
                            null,
                            this.props.textEDM
                        ) : ''
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'submit-box' },
                        _react2.default.createElement(
                            'a',
                            { className: 'submit', onClick: this.onSendSMSCode },
                            _i18n2.default.SEND_SMS_CODE
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'agreement-wrap agreement-wrap-phone' },
                        _i18n2.default.SMS_POLICY
                    )
                ) : null,
                this.state.isShowVerificationTab ? _react2.default.createElement(_verification2.default, {
                    cellPhone: '+' + this.cellPhone,
                    countryCode: this.state.countryCode,
                    phoneValue: this.state.phoneValue,
                    editNumber: this.showPhoneTab,
                    showEmail: this.props.showEmail,
                    nCf: this.props.nCf,
                    registerFrom: this.props.registerFrom,
                    sendSMSAjax: this.checkSMSAjax,
                    isResend: this.getResend,
                    countDownTimer: this.setCountDownTimer,
                    getShowCodeTip: this.getShowCodeTip,
                    getCountDown: this.getCountDown,
                    isShowCodeTip: this.state.isShowCodeTip,
                    showCodeTip: this.state.showCodeTip,
                    showResendCode: this.state.showResendCode,
                    showCountDown: this.state.showCountDown,
                    showPwdTab: this.showPwdTab,
                    toggleMask: this.props.toggleMask,
                    showAgreement: this.props.showAgreement,
                    isShowEDM: this.props.isShowEDM,
                    allowEDM: this.props.allowEDM,
                    textEDM: this.props.textEDM,
                    handleChangeEDM: function handleChangeEDM(params) {
                        _this3.props.handleChangeEDM(params);
                    }

                }) : null,
                this.state.isShowPwdTab ? _react2.default.createElement(_phonepwd2.default, {
                    showViaEmail: this.props.showViaEmail,
                    registerFrom: this.props.registerFrom,
                    nCf: this.props.nCf,
                    actionUrl: this.props.actionUrl,
                    freeLogin: this.props.freeLogin,
                    sessionId: this.props.sessionId,
                    ncData: this.ncData,
                    toggleMask: this.props.toggleMask,
                    countryCodeFormat: this.countryCodeFormat,
                    batmanNav: this.props.batmanNav,
                    countryCode: this.state.countryCode,
                    phoneValue: this.state.phoneValue,
                    cellPhone: this.cellPhone,
                    showAgreement: this.props.showAgreement,
                    showSNS: this.props.showSNS,
                    phoneNc: this.phoneNc,
                    getBeginSendPostTime: this.props.getBeginSendPostTime,
                    isShowEDM: this.props.isShowEDM,
                    allowEDM: this.props.allowEDM,
                    textEDM: this.props.textEDM,
                    handleChangeEDM: function handleChangeEDM(params) {
                        _this3.props.handleChangeEDM(params);
                    }
                }) : null
            );
        }

        // 曝光打点

    }, {
        key: 'ctrDot',
        value: function ctrDot(arg) {
            _zoroClickstat2.default.ctr({
                expType: arg.expType
            });
        }

        // 点击打点

    }, {
        key: 'clickDot',
        value: function clickDot(arg) {
            _zoroClickstat2.default.buttonClick({
                buttonType: arg.buttonType,
                objectType: arg.objectType
            });
        }
    }]);
    return TelePhone;
}(_react.Component), _class.propTypes = {
    showAgreement: _propTypes2.default.func,
    countryCode: _propTypes2.default.string,
    countryCodeClassName: _propTypes2.default.string,
    allowEDM: _propTypes2.default.bool,
    textEDM: _propTypes2.default.string,
    handleChangeEDM: _propTypes2.default.func,
    toggleMask: _propTypes2.default.func,
    nCf: _propTypes2.default.object,
    registerFrom: _propTypes2.default.string,
    mailSignIn: _propTypes2.default.func,
    showEmail: _propTypes2.default.func,
    showViaEmail: _propTypes2.default.func,
    actionUrl: _propTypes2.default.string,
    freeLogin: _propTypes2.default.func,
    sessionId: _propTypes2.default.string,
    batmanNav: _propTypes2.default.func,
    showSNS: _propTypes2.default.func,
    getBeginSendPostTime: _propTypes2.default.func
}, _temp);
exports.default = TelePhone;